import axios from "axios";

const api = axios.create({ baseURL: "/api" });

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("wa_token");
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export default api;
